import React from 'react';
import {Message} from "types/Message";
import Empty from "components/Empty";
import {MailOpenIcon} from "@heroicons/react/outline";
import {NavLink} from "react-router-dom";
import {formattedDateTime} from "services/date";

type Props = {
    messages: Array<Message>
}

function MessageSchedule({messages}: Props) {
    return (
        <>
            {!messages.length &&
                <Empty text="No scheduled messages" icon={MailOpenIcon}/>
            }

            {!!messages.length &&
                <ul className="divide-y divide-gray-200">
                    {messages.map(message => (
                        <li
                            key={message.id}
                            className="relative bg-white py-5 px-4 focus-within:ring-2 focus-within:ring-inset focus-within:ring-brand hover:bg-gray-50"
                        >
                            <div className="flex justify-between space-x-3">
                                <div className="min-w-0 flex-1">
                                    <NavLink to={`/messages/${message.id}`} className="block focus:outline-none">
                                        <span className="absolute inset-0" aria-hidden="true"/>
                                        <p className="truncate text-sm font-medium text-gray-900">{message.subject}</p>
                                        <p className="truncate text-sm text-gray-500">{message.snippet}</p>
                                    </NavLink>
                                </div>
                                <time dateTime={message.due_at?.toISO()}
                                      className="flex-shrink-0 whitespace-nowrap text-sm text-gray-500">
                                    {formattedDateTime(message.due_at)}
                                </time>
                            </div>
                        </li>
                    ))}
                </ul>
            }
        </>
    );
}

export default MessageSchedule;